import styled from "@emotion/styled";

export interface PreloaderContainerProps {
    sideLength: number;
}

export const PreloaderContainer = styled("div")<PreloaderContainerProps>`
    height: ${({ sideLength }) => sideLength}px;
    width: ${({ sideLength }) => sideLength}px;
`;
